export default function HeliviewLogo({ size = 32 }) {
  return <img src="/icon.svg" alt="" width={size} height={size} style={{ display: 'block', flexShrink: 0 }}/>
}
